import { ref, computed } from 'vue'
import { HTTP } from '@/Api/http-common'

const config = ref(null)
const loading = ref(false)
const error = ref(null)
let loaded = false

// Default fallback config for offline or error states
const FALLBACK_CONFIG = {
  currency: 'جنيه',
  price: '3525',
  price_normal: '3525',
  price_text_ar: 'السعر شامل الضريبة',
  result_mode: 'not_live',
  text_box1: 'ادخل رقم الجلوس او رقم الإستمارة',
  title_ar: 'نتيجة القبول العام للجامعات السودانية\nللعام 2024',
  year: '2024-2025'
}

export function useSystemConfig() {
  /**
   * Fetch system configuration from API
   */
  async function fetchConfig() {
    if (loaded) return
    loading.value = true
    error.value = null
    
    try {
      const response = await HTTP.post('GetSystemConfig.php')
      
      // Check if response has valid config
      if (response?.data?.config && !response.data.error) {
        config.value = response.data.config
        
        // Cache result_mode to localStorage for global access
        if (response.data.config.result_mode) {
          localStorage.setItem('result_mode', response.data.config.result_mode)
        }
      } else {
        // API returned error
        error.value = response?.data?.message_ar || 'فشل في جلب إعدادات النظام'
        config.value = FALLBACK_CONFIG
        localStorage.setItem('result_mode', FALLBACK_CONFIG.result_mode)
      }
    } catch (err) {
      // Network or other errors
      console.error('System config fetch error:', err)
      error.value = 'فشل الاتصال بخادم الإعدادات'
      config.value = FALLBACK_CONFIG
      localStorage.setItem('result_mode', FALLBACK_CONFIG.result_mode)
    } finally {
      loading.value = false
      loaded = true
    }
  }

  /**
   * Reset config to allow refetch
   */
  function resetConfig() {
    loaded = false
    config.value = null
    error.value = null
  }

  /**
   * Computed property to check if system is in live mode
   */
  const isLive = computed(() => {
    return config.value?.result_mode === 'live'
  })

  /**
   * Computed property for formatted price
   */
  const formattedPrice = computed(() => {
    if (!config.value?.price) return '0'
    return config.value.price.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  })

  /**
   * Get price with currency
   */
  const priceWithCurrency = computed(() => {
    return `${formattedPrice.value} ${config.value?.currency || 'جنيه'}`
  })

  return {
    config,
    loading,
    error,
    isLive,
    formattedPrice,
    priceWithCurrency,
    fetchConfig,
    resetConfig
  }
}
